var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrice01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7269 23.3935L29.7334 23.39H29.7208L22.3414 19.3914L14.9498 15.3857L7.55792 19.3914L0.178573 23.39H0.166016L0.17244 23.3935L0.166016 23.397H0.178573L7.55792 27.3956L14.9498 31.4012L22.3414 27.3956L29.7208 23.397H29.7334L29.7269 23.3935Z",
    fill: "#DCD8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7269 8.03558L29.7334 8.03236H29.7208L22.3414 4.03346L14.9498 0.027832L7.55792 4.03346L0.178573 8.03236H0.166016L0.17244 8.03558L0.166016 8.03909H0.178573L7.55792 12.038L14.9498 16.0436L22.3414 12.038L29.7208 8.03909H29.7334L29.7269 8.03558Z",
    fill: "#7539FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.177734 7.71021V23.719L14.949 15.7147L0.177734 7.71021Z",
    fill: "#B8B1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7202 7.71021V23.719L14.9492 15.7147L29.7202 7.71021Z",
    fill: "#B8B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice01);
export default __webpack_public_path__ + "static/media/price-01.a99ea3c92ce52c28c131ac5b6ead86cf.svg";
export { ForwardRef as ReactComponent };